import React from "react";
import ReactTooltip from "react-tooltip";
import CommonPortal from "./modals/common/CommonPortal";


function CommonToolTip(props) {
    const { id, className, place = "top", clickable = false, arrowColor = "#000" , event="" } = props;
    return (
        <CommonPortal>
            <ReactTooltip
                id={id}
                className={className}
                place={place}
                html={true}
                type="dark"
                effect="solid"
                clickable={clickable}
                event={event}
                arrowColor={arrowColor}
            >{props.content}</ReactTooltip>
        </CommonPortal>
    )

}


export default CommonToolTip;